import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=744c4fe6&scoped=true"
import script from "./EditService.vue?vue&type=script&lang=js"
export * from "./EditService.vue?vue&type=script&lang=js"
import style0 from "./EditService.vue?vue&type=style&index=0&id=744c4fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c4fe6",
  null
  
)

export default component.exports